type Game3Map = {
  intro: string[]
  hooves: {
    label: string
    data: Array<{
      id: string
      label: string
      img: string
      imgFootprint: string
      imgDetail: string
    }>
  }
  paws: {
    label: string
    data: Array<{
      id: string
      label: string
      img: string
      imgFootprint: string
      imgDetail: string
    }>
  }
  correctMessages: string[]
  errorMessages: string[]
}

const hooves = [
  {
    id: 'deer',
    label: 'Jelen evropský lesní',
    img: require('../assets/game3/01_jelen_Pospisil-min.jpg').default,
    imgFootprint: require('../assets/game3/01_stopa_jelen-min.jpg').default,
    imgDetail: require('../assets/game3/01_jelen_info-min.jpg').default,
  },
  {
    id: 'buck',
    label: 'Srnec obecný',
    img: require('../assets/game3/02_srnec_Kratochvil-min.jpg').default,
    imgFootprint: require('../assets/game3/02_stopa_srnec-min.jpg').default,
    imgDetail: require('../assets/game3/02_srnec_info-min.jpg').default,
  },
  {
    id: 'fallow',
    label: 'Daněk skvrnitý',
    img: require('../assets/game3/03_danek_skvrnity_mezistromy-min.jpg').default,
    imgFootprint: require('../assets/game3/03_stopa_danek-min.jpg').default,
    imgDetail: require('../assets/game3/03_danek_info-min.jpg').default,
  },
  {
    id: 'pig',
    label: 'Prase divoké',
    img: require('../assets/game3/04_prase_II_Pospisil-min.jpg').default,
    imgFootprint: require('../assets/game3/04_stopa_divprase-min.jpg').default,
    imgDetail: require('../assets/game3/04_divprase_info-min.jpg').default,
  },
]

const paws = [
  {
    id: 'fox',
    label: 'Liška obecná',
    img: require('../assets/game3/05_liska_Saj-min.jpg').default,
    imgFootprint: require('../assets/game3/05_stopa_liska-min.jpg').default,
    imgDetail: require('../assets/game3/05_liska_info-min.jpg').default,
  },
  {
    id: 'marten',
    label: 'Kuna skalní',
    img: require('../assets/game3/06_kuna_skalni_Kasina-min.jpg').default,
    imgFootprint: require('../assets/game3/06_stopa_kuna-min.jpg').default,
    imgDetail: require('../assets/game3/06_kuna_info-min.jpg').default,
  },
  {
    id: 'hare',
    label: 'Zajíc polní',
    img: require('../assets/game3/07_Zajic_Hlavica-min.jpg').default,
    imgFootprint: require('../assets/game3/07_stopa_zajic-min.jpg').default,
    imgDetail: require('../assets/game3/07_zajic_info-min.jpg').default,
  },
]

export const Game3Map: Game3Map = {
  intro: [
    'Nejlépe se zvěř stopuje v zimě, na sněhu. Poznáš, kterému zvířeti patří která stopa?',
    'Vyber fotku zvířete k jeho stopě. Pokud ji přiřadíš správně, po kliknutí na tlačítko „Čeho si všímat?“se dozvíš typické znaky každé stopy.',
  ],
  hooves: { label: 'Spárkatá zvěř', data: hooves },
  paws: { label: 'Tlapkatá zvěř', data: paws },
  correctMessages: ['Správně.', 'Výborně.', 'Trefa do černého.'],
  errorMessages: ['Kdepak.', 'Zkus to znovu.', 'Prach a broky, to není ono..'],
}
